<div *ngIf="showToast" class="w-12 toast" role="status" aria-live="polite" aria-atomic="true">
  <div [ngClass]="toastStyle" class="p-3 flex justify-content-between shadow-1 border-round-lg font-normal">
    <!-- Left: Icon + Text -->
    <div class="flex align-items-start gap-3">
      <i [ngClass]="toastIconStyle" class="text-lg font-medium"></i>
      <div>
        <!-- Title may contain HTML (e.g. clickable phone links) -->
        <p *ngIf="toastTitle" class="font-medium m-0" [innerHTML]="toastTitle" appGaButtonClick [buttonLocation]="location"
          [buttonName]="buttonName"></p>
        <p class="m-0" *ngIf="toastmessage || toastLink">
          <span *ngIf="toastmessage" [innerHTML]="toastmessage"></span>
          <span *ngIf="toastmessage && toastLink"> </span>
          <span *ngIf="toastLink" [innerHTML]="toastLink | phone:true" appGaButtonClick [buttonLocation]="location"
            [buttonName]="buttonName" class="message-link underline ml-1">
          </span>
          <ng-content select="[extra-text]"></ng-content>
        </p>
        <ng-content></ng-content>
      </div>
    </div>

    <!-- Right: Close Button -->
    <i *ngIf="closable" class="pi pi-times cursor-pointer" (click)="closeToast()"></i>
  </div>
</div>
